import { createFileRoute } from '@tanstack/react-router'
import { PanduanStaff } from '../../../../components/PanduanStaff'

export const Route = createFileRoute('/platform/desa/$desaId/panduan')({
  component: PanduanStaff,
})
